import { useLang } from "@/lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const ITEMS = [t("mq1"), t("mq2"), t("mq3"), t("mq4"), t("mq5"), t("mq6"), t("mq7")];
  const strip = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div
      className="relative overflow-hidden bg-[#F26522] py-3 border-y border-[#0E1A2B]/20"
      data-testid="marquee-strip"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {strip.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-mono text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-[#0E1A2B]"
              >
                <span className="px-6">{item}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-[#0E1A2B]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
